import { Box, type PaperProps } from "@mui/material";

export const BasePaper = (
  props: PaperProps & {
    variant?: "outlined" | "elevation";
  },
) => {
  const { sx, ...rest } = props;
  const borderSx =
    props.variant === "elevation"
      ? {
          borderRadius: "16px",
          border: "1px solid #E4E5E5",
          boxShadow: "0px 1px 10px 0px #0000001A",
        }
      : {
          borderRadius: "16px",
          border: "1px solid #E4E5E5",
          boxShadow: "0 0 0 0",
        };
  return (
    <Box
      sx={{
        ...borderSx,
        backgroundColor: "white",
        ...sx,
      }}
      {...rest}
    />
  );
};
